import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../app/store";

export interface NotificationModel {
    type: "success" | "error";
    message: string;
    /** Set for a company-role refusal: the backend's package name and the access level it needed, when it sent them. */
    forbidden?: { package?: string, access?: string };
}

export interface NotificationsState {
    queue: Array<NotificationModel>;
}

const initialState: NotificationsState = {
    queue: [],
}

export const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        showSuccess: (state, action) => {
            const anySuccess = state.queue.some(n => n.type === 'success')
            if (!anySuccess) {
                state.queue.push({
                    type: "success",
                    message: action.payload,
                });
            }
        },
        showError: (state, action) => {
            state.queue.push({
                type: "error",
                message: action.payload,
            });
        },
        showForbidden: (state, action: PayloadAction<{ package?: string, access?: string }>) => {
            // A page firing several requests shouldn't stack identical toasts.
            const duplicate = state.queue.some(n =>
                n.forbidden?.package === action.payload.package && n.forbidden?.access === action.payload.access)
            if (!duplicate) {
                state.queue.push({
                    type: "error",
                    message: action.payload.package ? "error-forbidden-package" : "error-forbidden",
                    forbidden: action.payload,
                });
            }
        },
        dequeueNotification: (state) => {
            state.queue.shift();
        },
    }
})

export const { showError, showSuccess, showForbidden, dequeueNotification } = notificationsSlice.actions

export const selectNotifications = (state: RootState) => state.notifications

export default notificationsSlice.reducer
